export const state = () => ({
  frontMenuProductDynamicDataList: null,
});
